import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import airticket from './modules/airticket'
import transaction from './modules/transaction'
import individual from './modules/individual'
import group from './modules/group'

Vue.use(Vuex)

export default new Vuex.Store({
  getters,
  modules: {
    user,
    airticket,
    transaction,
    individual,
    group
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js